/**
 * Postgres default stop-word lists (from tsearch_data/*.stop), keyed by our
 * supported locale codes — the same lists the server's text-search config
 * drops from tsqueries. Keep in sync with LANGUAGE_MAP in
 * libs/trpc-server/src/lib/exercise-library/router.ts.
 */
export const STOP_WORDS: Record<string, ReadonlySet<string>> = {
  en: new Set([
    "i", "me", "my", "myself", "we", "our", "ours", "ourselves",
    "you", "your", "yours", "yourself", "yourselves", "he", "him", "his",
    "himself", "she", "her", "hers", "herself", "it", "its", "itself",
    "they", "them", "their", "theirs", "themselves", "what", "which", "who",
    "whom", "this", "that", "these", "those", "am", "is", "are",
    "was", "were", "be", "been", "being", "have", "has", "had",
    "having", "do", "does", "did", "doing", "a", "an", "the",
    "and", "but", "if", "or", "because", "as", "until", "while",
    "of", "at", "by", "for", "with", "about", "against", "between",
    "into", "through", "during", "before", "after", "above", "below", "to",
    "from", "up", "down", "in", "out", "on", "off", "over",
    "under", "again", "further", "then", "once", "here", "there", "when",
    "where", "why", "how", "all", "any", "both", "each", "few",
    "more", "most", "other", "some", "such", "no", "nor", "not",
    "only", "own", "same", "so", "than", "too", "very", "s",
    "t", "can", "will", "just", "don", "should", "now",
  ]),
  de: new Set([
    "aber", "alle", "allem", "allen", "aller", "alles", "als", "also",
    "am", "an", "ander", "andere", "anderem", "anderen", "anderer", "anderes",
    "anderm", "andern", "anderr", "anders", "auch", "auf", "aus", "bei",
    "bin", "bis", "bist", "da", "damit", "dann", "der", "den",
    "des", "dem", "die", "das", "daß", "derselbe", "derselben", "denselben",
    "desselben", "demselben", "dieselbe", "dieselben", "dasselbe", "dazu", "dein", "deine",
    "deinem", "deinen", "deiner", "deines", "denn", "derer", "dessen", "dich",
    "dir", "du", "dies", "diese", "diesem", "diesen", "dieser", "dieses",
    "doch", "dort", "durch", "ein", "eine", "einem", "einen", "einer",
    "eines", "einig", "einige", "einigem", "einigen", "einiger", "einiges", "einmal",
    "er", "ihn", "ihm", "es", "etwas", "euer", "eure", "eurem",
    "euren", "eurer", "eures", "für", "gegen", "gewesen", "hab", "habe",
    "haben", "hat", "hatte", "hatten", "hier", "hin", "hinter", "ich",
    "mich", "mir", "ihr", "ihre", "ihrem", "ihren", "ihrer", "ihres",
    "euch", "im", "in", "indem", "ins", "ist", "jede", "jedem",
    "jeden", "jeder", "jedes", "jene", "jenem", "jenen", "jener", "jenes",
    "jetzt", "kann", "kein", "keine", "keinem", "keinen", "keiner", "keines",
    "können", "könnte", "machen", "man", "manche", "manchem", "manchen", "mancher",
    "manches", "mein", "meine", "meinem", "meinen", "meiner", "meines", "mit",
    "muss", "musste", "nach", "nicht", "nichts", "noch", "nun", "nur",
    "ob", "oder", "ohne", "sehr", "sein", "seine", "seinem", "seinen",
    "seiner", "seines", "selbst", "sich", "sie", "ihnen", "sind", "so",
    "solche", "solchem", "solchen", "solcher", "solches", "soll", "sollte", "sondern",
    "sonst", "über", "um", "und", "uns", "unse", "unsem", "unsen",
    "unser", "unses", "unter", "viel", "vom", "von", "vor", "während",
    "war", "waren", "warst", "was", "weg", "weil", "weiter", "welche",
    "welchem", "welchen", "welcher", "welches", "wenn", "werde", "werden", "wie",
    "wieder", "will", "wir", "wird", "wirst", "wo", "wollen", "wollte",
    "würde", "würden", "zu", "zum", "zur", "zwar", "zwischen",
  ]),
  it: new Set([
    "ad", "al", "allo", "ai", "agli", "all", "agl", "alla",
    "alle", "con", "col", "coi", "da", "dal", "dallo", "dai",
    "dagli", "dall", "dagl", "dalla", "dalle", "di", "del", "dello",
    "dei", "degli", "dell", "degl", "della", "delle", "in", "nel",
    "nello", "nei", "negli", "nell", "negl", "nella", "nelle", "su",
    "sul", "sullo", "sui", "sugli", "sull", "sugl", "sulla", "sulle",
    "per", "tra", "contro", "io", "tu", "lui", "lei", "noi",
    "voi", "loro", "mio", "mia", "miei", "mie", "tuo", "tua",
    "tuoi", "tue", "suo", "sua", "suoi", "sue", "nostro", "nostra",
    "nostri", "nostre", "vostro", "vostra", "vostri", "vostre", "mi", "ti",
    "ci", "vi", "lo", "la", "li", "le", "gli", "ne",
    "il", "un", "uno", "una", "ma", "ed", "se", "perché",
    "anche", "come", "dov", "dove", "che", "chi", "cui", "non",
    "più", "quale", "quanto", "quanti", "quanta", "quante", "quello", "quelli",
    "quella", "quelle", "questo", "questi", "questa", "queste", "si", "tutto",
    "tutti", "a", "c", "e", "i", "l", "o", "ho",
    "hai", "ha", "abbiamo", "avete", "hanno", "abbia", "abbiate", "abbiano",
    "avrò", "avrai", "avrà", "avremo", "avrete", "avranno", "avrei", "avresti",
    "avrebbe", "avremmo", "avreste", "avrebbero", "avevo", "avevi", "aveva", "avevamo",
    "avevate", "avevano", "ebbi", "avesti", "ebbe", "avemmo", "aveste", "ebbero",
    "avessi", "avesse", "avessimo", "avessero", "avendo", "avuto", "avuta", "avuti",
    "avute", "sono", "sei", "è", "siamo", "siete", "sia", "siate",
    "siano", "sarò", "sarai", "sarà", "saremo", "sarete", "saranno", "sarei",
    "saresti", "sarebbe", "saremmo", "sareste", "sarebbero", "ero", "eri", "era",
    "eravamo", "eravate", "erano", "fui", "fosti", "fu", "fummo", "foste",
    "furono", "fossi", "fosse", "fossimo", "fossero", "essendo", "faccio", "fai",
    "facciamo", "fanno", "faccia", "facciate", "facciano", "farò", "farai", "farà",
    "faremo", "farete", "faranno", "farei", "faresti", "farebbe", "faremmo", "fareste",
    "farebbero", "facevo", "facevi", "faceva", "facevamo", "facevate", "facevano", "feci",
    "facesti", "fece", "facemmo", "faceste", "fecero", "facessi", "facesse", "facessimo",
    "facessero", "facendo", "sto", "stai", "sta", "stiamo", "stanno", "stia",
    "stiate", "stiano", "starò", "starai", "starà", "staremo", "starete", "staranno",
    "starei", "staresti", "starebbe", "staremmo", "stareste", "starebbero", "stavo", "stavi",
    "stava", "stavamo", "stavate", "stavano", "stetti", "stesti", "stette", "stemmo",
    "steste", "stettero", "stessi", "stesse", "stessimo", "stessero", "stando",
  ]),
  pt: new Set([
    "de", "a", "o", "que", "e", "do", "da", "em",
    "um", "para", "com", "não", "uma", "os", "no", "se",
    "na", "por", "mais", "as", "dos", "como", "mas", "ao",
    "ele", "das", "à", "seu", "sua", "ou", "quando", "muito",
    "nos", "já", "eu", "também", "só", "pelo", "pela", "até",
    "isso", "ela", "entre", "depois", "sem", "mesmo", "aos", "seus",
    "quem", "nas", "me", "esse", "eles", "você", "essa", "num",
    "nem", "suas", "meu", "às", "minha", "numa", "pelos", "elas",
    "qual", "nós", "lhe", "deles", "essas", "esses", "pelas", "este",
    "dele", "tu", "te", "vocês", "vos", "lhes", "meus", "minhas",
    "teu", "tua", "teus", "tuas", "nosso", "nossa", "nossos", "nossas",
    "dela", "delas", "esta", "estes", "estas", "aquele", "aquela", "aqueles",
    "aquelas", "isto", "aquilo", "estou", "está", "estamos", "estão", "estive",
    "esteve", "estivemos", "estiveram", "estava", "estávamos", "estavam", "estivera", "estivéramos",
    "esteja", "estejamos", "estejam", "estivesse", "estivéssemos", "estivessem", "estiver", "estivermos",
    "estiverem", "hei", "há", "havemos", "hão", "houve", "houvemos", "houveram",
    "houvera", "houvéramos", "haja", "hajamos", "hajam", "houvesse", "houvéssemos", "houvessem",
    "houver", "houvermos", "houverem", "houverei", "houverá", "houveremos", "houverão", "houveria",
    "houveríamos", "houveriam", "sou", "somos", "são", "era", "éramos", "eram",
    "fui", "foi", "fomos", "foram", "fora", "fôramos", "seja", "sejamos",
    "sejam", "fosse", "fôssemos", "fossem", "for", "formos", "forem", "serei",
    "será", "seremos", "serão", "seria", "seríamos", "seriam", "tenho", "tem",
    "temos", "tém", "tinha", "tínhamos", "tinham", "tive", "teve", "tivemos",
    "tiveram", "tivera", "tivéramos", "tenha", "tenhamos", "tenham", "tivesse", "tivéssemos",
    "tivessem", "tiver", "tivermos", "tiverem", "terei", "terá", "teremos", "terão",
    "teria", "teríamos", "teriam",
  ]),
  es: new Set([
    "de", "la", "que", "el", "en", "y", "a", "los",
    "del", "se", "las", "por", "un", "para", "con", "no",
    "una", "su", "al", "lo", "como", "más", "pero", "sus",
    "le", "ya", "o", "este", "sí", "porque", "esta", "entre",
    "cuando", "muy", "sin", "sobre", "también", "me", "hasta", "hay",
    "donde", "quien", "desde", "todo", "nos", "durante", "todos", "uno",
    "les", "ni", "contra", "otros", "ese", "eso", "ante", "ellos",
    "e", "esto", "mí", "antes", "algunos", "qué", "unos", "yo",
    "otro", "otras", "otra", "él", "tanto", "esa", "estos", "mucho",
    "quienes", "nada", "muchos", "cual", "poco", "ella", "estar", "estas",
    "algunas", "algo", "nosotros", "mi", "mis", "tú", "te", "ti",
    "tu", "tus", "ellas", "nosotras", "vosostros", "vosostras", "os", "mío",
    "mía", "míos", "mías", "tuyo", "tuya", "tuyos", "tuyas", "suyo",
    "suya", "suyos", "suyas", "nuestro", "nuestra", "nuestros", "nuestras", "vuestro",
    "vuestra", "vuestros", "vuestras", "esos", "esas", "estoy", "estás", "está",
    "estamos", "estáis", "están", "esté", "estés", "estemos", "estéis", "estén",
    "estaré", "estarás", "estará", "estaremos", "estaréis", "estarán", "estaría", "estarías",
    "estaríamos", "estaríais", "estarían", "estaba", "estabas", "estábamos", "estabais", "estaban",
    "estuve", "estuviste", "estuvo", "estuvimos", "estuvisteis", "estuvieron", "estuviera", "estuvieras",
    "estuviéramos", "estuvierais", "estuvieran", "estuviese", "estuvieses", "estuviésemos", "estuvieseis", "estuviesen",
    "estando", "estado", "estada", "estados", "estadas", "estad", "he", "has",
    "ha", "hemos", "habéis", "han", "haya", "hayas", "hayamos", "hayáis",
    "hayan", "habré", "habrás", "habrá", "habremos", "habréis", "habrán", "habría",
    "habrías", "habríamos", "habríais", "habrían", "había", "habías", "habíamos", "habíais",
    "habían", "hube", "hubiste", "hubo", "hubimos", "hubisteis", "hubieron", "hubiera",
    "hubieras", "hubiéramos", "hubierais", "hubieran", "hubiese", "hubieses", "hubiésemos", "hubieseis",
    "hubiesen", "habiendo", "habido", "habida", "habidos", "habidas", "soy", "eres",
    "es", "somos", "sois", "son", "sea", "seas", "seamos", "seáis",
    "sean", "seré", "serás", "será", "seremos", "seréis", "serán", "sería",
    "serías", "seríamos", "seríais", "serían", "era", "eras", "éramos", "erais",
    "eran", "fui", "fuiste", "fue", "fuimos", "fuisteis", "fueron", "fuera",
    "fueras", "fuéramos", "fuerais", "fueran", "fuese", "fueses", "fuésemos", "fueseis",
    "fuesen", "sintiendo", "sentido", "sentida", "sentidos", "sentidas", "siente", "sentid",
    "tengo", "tienes", "tiene", "tenemos", "tenéis", "tienen", "tenga", "tengas",
    "tengamos", "tengáis", "tengan", "tendré", "tendrás", "tendrá", "tendremos", "tendréis",
    "tendrán", "tendría", "tendrías", "tendríamos", "tendríais", "tendrían", "tenía", "tenías",
    "teníamos", "teníais", "tenían", "tuve", "tuviste", "tuvo", "tuvimos", "tuvisteis",
    "tuvieron", "tuviera", "tuvieras", "tuviéramos", "tuvierais", "tuvieran", "tuviese", "tuvieses",
    "tuviésemos", "tuvieseis", "tuviesen", "teniendo", "tenido", "tenida", "tenidos", "tenidas",
    "tened",
  ]),
  fr: new Set([
    "au", "aux", "avec", "ce", "ces", "dans", "de", "des",
    "du", "elle", "en", "et", "eux", "il", "je", "la",
    "le", "leur", "lui", "ma", "mais", "me", "même", "mes",
    "moi", "mon", "ne", "nos", "notre", "nous", "on", "ou",
    "par", "pas", "pour", "qu", "que", "qui", "sa", "se",
    "ses", "son", "sur", "ta", "te", "tes", "toi", "ton",
    "tu", "un", "une", "vos", "votre", "vous", "c", "d",
    "j", "l", "à", "m", "n", "s", "t", "y",
    "été", "étée", "étées", "étés", "étant", "étante", "étants", "étantes",
    "suis", "es", "est", "sommes", "êtes", "sont", "serai", "seras",
    "sera", "serons", "serez", "seront", "serais", "serait", "serions", "seriez",
    "seraient", "étais", "était", "étions", "étiez", "étaient", "fus", "fut",
    "fûmes", "fûtes", "furent", "sois", "soit", "soyons", "soyez", "soient",
    "fusse", "fusses", "fût", "fussions", "fussiez", "fussent", "ayant", "ayante",
    "ayantes", "ayants", "eu", "eue", "eues", "eus", "ai", "as",
    "avons", "avez", "ont", "aurai", "auras", "aura", "aurons", "aurez",
    "auront", "aurais", "aurait", "aurions", "auriez", "auraient", "avais", "avait",
    "avions", "aviez", "avaient", "eut", "eûmes", "eûtes", "eurent", "aie",
    "aies", "ait", "ayons", "ayez", "aient", "eusse", "eusses", "eût",
    "eussions", "eussiez", "eussent",
  ]),
};
